import { render, staticRenderFns } from "./contactView.vue?vue&type=template&id=76d4681c&scoped=true"
import script from "./contactView.vue?vue&type=script&lang=ts"
export * from "./contactView.vue?vue&type=script&lang=ts"
import style0 from "./contactView.vue?vue&type=style&index=0&id=76d4681c&prod&lang=scss&scoped=true"
import style1 from "./contactView.vue?vue&type=style&index=1&id=76d4681c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d4681c",
  null
  
)

export default component.exports